import Modules from "./modules/modules";

new Modules().init();

jQuery(document).ready(function ($) {
    $("body").on("click", ".navigation-open-hamburger svg", function () {
        $(".header-container").toggleClass("active");
        $("body").toggleClass("active");
    });
    $("body").on("click", ".navigation-close-hamburger svg", function () {
        $(".header-container").toggleClass("active");
        $("body").toggleClass("active");
    });
    $("#site-navigation .menu-item-has-children").append(
        '<i class="submenu-open-icon fal fa-chevron-down"></i>'
    );
    $("body").on("click", ".submenu-open-icon", function () {
        $(this).toggleClass("fa-chevron-down").toggleClass("fa-horizontal-rule");
        $(this).closest(".menu-item-has-children").find(".sub-menu").slideToggle(300, "linear");
    });

    // help sticky
    $("body").on("click", ".img_help_new", function () {
        $(".modal_help").toggleClass("show");
    });
    $("body").on("click", ".btn_close_help", function () {
        $(".modal_help").toggleClass("show");
    });

    // page navigation
    $(".navigation:first").addClass("active");
    $(".section-wrapper:first").addClass("active");
    if ($(".section-wrapper:first").hasClass("icon")) {
        $(".nami__page-footer").addClass("no-sticky");
    }
    if ($(".section-wrapper:first").hasClass("resource")) {
        $(".nami__page-footer").addClass("no-sticky");
    }

    $(".navigation").click(function (e) {
        e.preventDefault();
        const id = $(this).attr("data-id");
        $(".navigation").removeClass("active");
        $(".section-wrapper").removeClass("active");
        $(this).addClass("active");
        const content = document.getElementById(id);
        content.classList.add("active");
        if (content.classList.contains("icon")) {
            $(".nami__page-footer").addClass("no-sticky");
        } else if (content.classList.contains("resource")) {
            $(".nami__page-footer").addClass("no-sticky");
        } else {
            $(".nami__page-footer").removeClass("no-sticky");
        }

    });

    const params = new URLSearchParams(window.location.search);
    if (params.has('section')) {
        const section = params.get('section');
        $(".navigation").removeClass("active");
        $(".section-wrapper").removeClass("active");
        $('[data-id="' + section + '"]').addClass("active");
        const content = document.getElementById(section);
        content.classList.add("active");
        if (content.classList.contains("icon")) {
            $(".nami__page-footer").addClass("no-sticky");
        } else if (content.classList.contains("resource")) {
            $(".nami__page-footer").addClass("no-sticky");
        } else {
            $(".nami__page-footer").removeClass("no-sticky");
        }
    }


    const elementToAppear = document.querySelectorAll('.in-view');


    document.querySelectorAll(".btnNav").forEach((element) => {
        element.addEventListener('click', e => {
            e.preventDefault();
            document.querySelectorAll("[data-nav].active").forEach((element) => {
                element.classList.remove('active')
            })
            const nav = e.currentTarget.dataset.nav;
            document.querySelectorAll("[data-nav='" + nav + "']").forEach((element) => {
                element.classList.add('active')
            })
        });
    })

    document.querySelectorAll(".btnTabExample").forEach((element) => {
        element.addEventListener('click', e => {
            e.preventDefault();
            document.querySelectorAll("[data-nav].active").forEach((element) => {
                element.classList.remove('active')
            })
            const nav = e.currentTarget.dataset.nav;
            document.querySelectorAll("[data-nav='" + nav + "']").forEach((element) => {
                element.classList.add('active')
            })
        });
    })

    document.querySelectorAll(".btnTab").forEach((element) => {
        element.addEventListener('click', e => {
            e.preventDefault();
            document.querySelectorAll("[data-tab].active").forEach((element) => {
                element.classList.remove('active')
            })
            const tab = e.currentTarget.dataset.tab;
            document.querySelectorAll("[data-tab='" + tab + "']").forEach((element) => {
                element.classList.add('active')
            })
        });
    });

    setTimeout(function () {
        const topNavigation = document.querySelector('#topNavigation');
        menuCreate(topNavigation);
        const hiddenNavigation = document.querySelector('#hiddenNavigation');
        menuCreate(hiddenNavigation);
    }, 800);
    setTimeout(function () {
        $('.section01').addClass('show');
    }, 900);
    setTimeout(function () {
        var paramsT = new URLSearchParams(window.location.search);
        var sectionT = paramsT.get('section');
        if (sectionT) {
            var contentT = document.getElementById(sectionT);
            contentT.scrollIntoView({behavior: 'smooth'});  //
        }
    }, 1100);
    setTimeout(function () {
        if (params.has('section')) {
            checkTabsActiveItem();
        } else {
            checkTabsFirstActiveItem();
        }
    }, 900);


    function checkVisible(elm) {
        if (elm) {
            var rect = elm.getBoundingClientRect();
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
        }
    }

    document.addEventListener("scroll", () => {
        elementToAppear.forEach((e) => {
            if (checkVisible(e)) {
                e.classList.add('show');
            }
        });
    });

    function checkTabsFirstActiveItem() {
        let tabElement = document.querySelector('.internal_nav');
        if (tabElement === null) {
            return;
        }
        let firstItem = tabElement.getElementsByTagName("a")[0];
        if (firstItem === null) {
            return;
        }
        firstItem.classList.add("active");
        let activeNav = firstItem.dataset.nav;
        let matchingElements = document.querySelectorAll(`[data-nav="${activeNav}"]`);
        matchingElements.forEach((element) => {
            element.classList.add('active');
        });
    }

    function checkTabsActiveItem() {
        let tabElements = document.querySelectorAll(".internal_nav a");
        tabElements.forEach(function (item) {
            if (item.classList.contains("active")) {
                let activeNav = item.dataset.nav;
                let matchingElements = document.querySelectorAll(`[data-nav="${activeNav}"]`);
                matchingElements.forEach((element) => {
                    element.classList.add('active');
                });
            }
        });
    }

    /*Burger Menu*/
    $('.btn_burger').click(function (e) {
        e.preventDefault();
        $('html').toggleClass('scroll');
        $(this).toggleClass('open');
        $(this).closest('.content_navigation').toggleClass('open');
    });

    /*Items*/
    $(document).on('click', '.item_link', function () {
        $(this).parent().toggleClass('open');
    });

    $('.slider_section03').each(function () {
        var $this = $(this);
        $this.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            fade: true,
            autoplay: true,
            speed: 800,
        });
        var countOfSlides = $this.slick('getSlick').slideCount;
        if (countOfSlides === 1) {
            $this.addClass('oneItem');
        }
    });

    function changeLang(checked) {
        let currentUrl = new URL(window.location.href);
        let newUrl;
        if (checked) {
            // User switched to Spanish
            if (!currentUrl.pathname.startsWith("/es/")) {
                newUrl = new URL(currentUrl.origin + "/es" + currentUrl.pathname);
            }
        } else {
            // User switched to English
            if (currentUrl.pathname.startsWith("/es/")) {
                newUrl = new URL(currentUrl.href.replace("es/", ""));
            }
        }
        // Redirect
        if (newUrl) window.location.href = newUrl.href;
    }

    const languageCheckboxMobile = document.querySelector("#checkbox_mobile_hidden");
    const languageCheckboxMobileHidden = document.querySelector("#checkbox_mobile");
    const languageCheckbox = document.querySelector("#checkboxHide");
    const languageCheckboxHidden = document.querySelector("#checkbox_hidden");
    const pathStartsWithEs = window.location.pathname.startsWith("/es/");
    languageCheckboxMobile.checked = pathStartsWithEs;
    languageCheckbox.checked = pathStartsWithEs;

    languageCheckboxMobile.addEventListener("change", function (e) {
        changeLang(e.target.checked);
    });
    languageCheckboxMobileHidden.addEventListener("change", function (e) {
        changeLang(e.target.checked);
    });
    languageCheckbox.addEventListener("change", function (e) {
        changeLang(e.target.checked);
    });
    languageCheckboxHidden.addEventListener("change", function (e) {
        changeLang(e.target.checked);
    });

    document.addEventListener('click', function (event) {
        var topNavigation = document.getElementById('topNavigation');
        var hiddenNavigation = document.getElementById('hiddenNavigation');
        var isClickInsideTopNav = topNavigation && topNavigation.contains(event.target);
        var isClickInsideHiddenNav = hiddenNavigation && hiddenNavigation.contains(event.target);
        var isBtnStudent = event.target.id === 'btnStudent';
        var isBtnEducators = event.target.id === 'btnEducator';
        if (!isClickInsideTopNav && !isClickInsideHiddenNav && !isBtnStudent && !isBtnEducators) {
            if (topNavigation) {
                topNavigation.classList.remove('open');
            }
            if (hiddenNavigation) {
                hiddenNavigation.classList.remove('open');
            }
        }
    });
    var scrollContainer = document.querySelector('.internal .section04 .content_section04');
    document.querySelectorAll('.internal .section04 .content_section04 .internal_nav .tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
            var additionalOffset = 20;
            var tabPositionX = tab.getBoundingClientRect().left - scrollContainer.getBoundingClientRect().left;
            var scrollPositionX = tabPositionX + (tab.offsetWidth / 2) - (scrollContainer.offsetWidth / 2) - additionalOffset;
            scrollContainer.scrollLeft = scrollPositionX;
        });
    });
});

/*Navigation Menu*/
function menuCreate(nav) {
    const navSections = nav.querySelectorAll('.content_guide');
    const links = nav.querySelectorAll('.link');
    links.forEach(_item => {
        _item.addEventListener('click', e => {
            e.preventDefault();
            if (_item.classList.contains('active')) {
                if (!document.querySelector('.content_mobile').checkVisibility()) {
                    nav.classList.remove('open');
                }
                navSections.forEach(_navSection => {
                    _navSection.classList.remove('open');
                });
                _item.classList.remove('active');
            } else {
                const dataSection = _item.getAttribute('data-section');
                nav.classList.add('open');
                navSections.forEach(_navSection => {
                    if (_navSection.getAttribute('data-section') == dataSection) {
                        _navSection.classList.add('open');
                    } else {
                        _navSection.classList.remove('open');
                    }
                });

                links.forEach(_i => {
                    _i.classList.remove('active');
                })
                _item.classList.add('active');
            }
        })
    });
}

/*Menu hide*/
const cntNavitationItem = document.querySelector(".hide_navigation");
var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
    var menuHidden = document.getElementById('hiddenNavigation');
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
        cntNavitationItem.classList.add("active");
    } else {
        if (!menuHidden.classList.contains('open')) {
            cntNavitationItem.classList.remove("active");
        }
    }
    if (currentScrollPos < 600) {
        cntNavitationItem.classList.remove("active");
    }
    prevScrollpos = currentScrollPos;
}
